import { useNavigate } from 'react-router';

import { ISignInData } from '../../models/auth/signIn.model';
import { SuccessHttpResponse } from '../../models/https';
import { authActions } from '../../redux/slices/authSlice';
import { useAppDisPatch } from '../../redux/store';

const useSetAuthentication = () => {
  const navigate = useNavigate();
  const dispatch = useAppDisPatch();

  const setAuthentication = ({
    data,
  }: SuccessHttpResponse<ISignInData>) => {
    dispatch(
      authActions.setAuthentication({ authData: data, isAuthenticated: true })
    );
    localStorage.setItem('authData', JSON.stringify(data));
    navigate(`/`, { replace: true });
  };

  return {
    setAuthentication,
  };
};

export default useSetAuthentication;
